import React from 'react';
import PropTypes from 'prop-types';
import { useTabsNavigationStore, useSmenaGamesStore, APP_VIEWS, SHIFT_SECTIONS } from '../../../stores';
import { SIDEBAR_SECTIONS, SIDEBAR_GAMES } from '../model/navModel';

// .side-nav — разделы смены + под-список игр (.side-sub).
// Функционал 1:1 со старым SectionTabs: setSection / setGame, фильтр игр по активным.
export default function SidebarNav({ onNavigate }) {
    const currentView = useTabsNavigationStore(state => state.currentView);
    const selectedSection = useTabsNavigationStore(state => state.selectedSection);
    const selectedGame = useTabsNavigationStore(state => state.selectedGame);
    const setSection = useTabsNavigationStore(state => state.setSection);
    const setGame = useTabsNavigationStore(state => state.setGame);
    const showShifts = useTabsNavigationStore(state => state.showShifts);

    const activeGames = useSmenaGamesStore(state => state.activeGames);
    const isGamesLoaded = useSmenaGamesStore(state => state.isLoaded);

    const inShifts = currentView === APP_VIEWS.SHIFTS;

    const handleSection = (section) => {
        if (!inShifts) showShifts();
        setSection(section);
        onNavigate();
    };

    const handleGame = (gameType) => {
        if (!inShifts) showShifts();
        if (selectedSection !== SHIFT_SECTIONS.GAMES) setSection(SHIFT_SECTIONS.GAMES);
        setGame(gameType);
        onNavigate();
    };

    const visibleGames = isGamesLoaded
        ? SIDEBAR_GAMES.filter(game => activeGames[game.type] === true)
        : [];

    const isSectionActive = (section) => inShifts && selectedSection === section;

    return (
        <nav className="side-nav">
            {SIDEBAR_SECTIONS.map(({ section, label, Icon, hasGames }) => (
                <React.Fragment key={section}>
                    <button
                        type="button"
                        className={`side-link${isSectionActive(section) ? ' on' : ''}`}
                        onClick={() => handleSection(section)}
                    >
                        <Icon />
                        {label}
                    </button>

                    {hasGames && visibleGames.length > 0 && (
                        <div className="side-sub">
                            {visibleGames.map(({ type, label: gameLabel }) => {
                                const active = inShifts
                                    && selectedSection === SHIFT_SECTIONS.GAMES
                                    && selectedGame === type;
                                return (
                                    <button
                                        type="button"
                                        key={type}
                                        className={active ? 'on' : undefined}
                                        onClick={() => handleGame(type)}
                                    >
                                        <span className="gd" />
                                        {gameLabel}
                                    </button>
                                );
                            })}
                        </div>
                    )}
                </React.Fragment>
            ))}
        </nav>
    );
}

SidebarNav.propTypes = {
    onNavigate: PropTypes.func.isRequired
};
